import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["rateField", "value", "showButton", "hideButton"];

  showRateField(event) {
    event.preventDefault();

    this.rateFieldTarget.classList.remove('hidden', 'opacity-0');
    this.rateFieldTarget.classList.add('flex', 'opacity-100');

    this.valueTarget.readOnly = true;

    this.showButtonTarget.classList.add('bg-blue-600');
    this.showButtonTarget.classList.remove('bg-blue-300', 'hover:bg-blue-600');

    this.hideButtonTarget.classList.add('bg-red-300', 'hover:bg-red-600');
    this.hideButtonTarget.classList.remove('bg-red-600');
  }

  hideRateField(event) {
    event.preventDefault();

    this.rateFieldTarget.classList.remove('flex', 'opacity-0');
    this.rateFieldTarget.classList.add('hidden', 'opacity-100');

    this.valueTarget.readOnly = false;

    this.hideButtonTarget.classList.add('bg-red-600');
    this.hideButtonTarget.classList.remove('bg-red-300', 'hover:bg-red-600');

    this.showButtonTarget.classList.add('bg-blue-300', 'hover:bg-blue-600');
    this.showButtonTarget.classList.remove('bg-blue-600');
  }
}
